import React, { Component } from 'react'

import Stats from './Components/Stats/index';
import Home from './Components/Home/index';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory
} from "react-router-dom";

export class App extends Component {

  componentDidMount() {
    //this.handleClick();
  }

  handleClick() {
    window.history.pushState({}, '', '/viewTokenStats');
  }
  render() {

    return (
      <div className="App">
        <Router>
            <Switch>
              <Route exact path="/">
              <Home />
                
              </Route>
              <Route path="/viewTokenStats">
              <Stats />
              </Route>
            </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
